import { useState } from "react";

export function useSwipeCoordination() {
  const [openRowId, setOpenRowId] = useState<string | null>(null);

  const handleSwipeStateChange = (conversationId: string, isOpen: boolean) => {
    if (isOpen) {
      setOpenRowId(conversationId);
    } else if (openRowId === conversationId) {
      setOpenRowId(null);
    }
  };

  const handleInteraction = () => {
    if (openRowId) {
      // Dispatch custom event to close all swipes
      window.dispatchEvent(new Event("closeAllSwipes"));
      setOpenRowId(null);
    }
  };

  return {
    handleSwipeStateChange,
    handleInteraction,
  };
}
